import * as React from "react";
const SvgFiRrWasher = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 0H7C4.243 0 2 2.243 2 5v14c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3zM6.5 6a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 6M9 4.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 9 4.5M12 8c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6m0 2c2.06 0 3.741 1.571 3.957 3.574-.274.193-.708.426-1.229.426-.839 0-1.828-.583-2.136-.807C12.425 13.071 10.917 12 9.273 12c-.271 0-.522.035-.762.084C9.192 10.849 10.492 10 12 10m0 8c-2.06 0-3.741-1.571-3.957-3.574.274-.193.708-.426 1.229-.426.839 0 1.828.583 2.136.807.167.122 1.675 1.193 3.319 1.193.271 0 .522-.035.762-.084C14.808 17.151 13.508 18 12 18"
    />
  </svg>
);
export default SvgFiRrWasher;
